<template>
  <v-dialog v-model="dialog" lazy width="854">
    <v-card>
      <v-toolbar dense color="primary" dark>
        <v-toolbar-title>
          {{
            language._id
              ? $t('titles.global.updateModel', {
                  field: $tc('models.language'),
                })
              : $t('titles.global.newModel', { field: $tc('models.language') })
          }}
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn dark icon @click="cancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap>
          <v-flex d-flex xs12 px-2>
            <translation-field
              ref="text"
              v-model="language.name"
              v-validate="'required'"
              :label="$t('fields.global.name')"
            />
          </v-flex>
          <v-flex md6 xs12 px-2>
            <v-text-field
              v-model="language.iso"
              v-validate="'required'"
              :label="$t('fields.language.iso') + ' (*)'"
              :data-vv-name="$t('fields.language.iso')"
              :error-messages="errors.collect($t('fields.language.iso'))"
            />
          </v-flex>
          <v-flex md6 xs12 px-2>
            <v-text-field
              v-model="language.order"
              v-validate="'required|numeric'"
              :label="$t('fields.global.order') + ' (*)'"
              type="number"
              :data-vv-name="$t('fields.global.order')"
              :error-messages="errors.collect($t('fields.global.order'))"
            />
          </v-flex>
          <v-flex md6 xs12 px-2>
            <v-switch
              v-model="language.active"
              :label="$t('fields.global.active')"
              color="primary"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <span style="color: red">(*) &nbsp;</span>
        <span>{{ $t('action.messages.fieldRequired') }}</span>
        <v-spacer />
        <meta-button type="reset" :disabled="loading" @click="clear" />
        <meta-button
          v-if="!language._id"
          type="create"
          :loading="loading"
          @click="submit()"
        />
        <meta-button
          v-else
          type="update"
          :loading="loading"
          @click="submit()"
        />
        <meta-button type="cancel" @click="cancel" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import TranslationField from '@/components/widgets/Input/TranslationField'
import { parseObject } from '@/helpers/utils'

export default {
  name: 'LanguageForm',
  components: {
    TranslationField,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {
      language: {},
    }
  },
  watch: {
    dialog(val) {
      if (!val) this.cancel()
    },
    selected: {
      handler: function (val) {
        if (val) {
          this.language = parseObject(val)
          this.language.name = val.name
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.language = parseObject(this.selected)
    this.language.name = this.selected.name
  },

  computed: {
    ...mapState({
      selected: (state) => state.languages.selected,
      loading: (state) => state.languages.loading,
    }),
  },
  methods: {
    ...mapActions({
      setCreate: 'languages/create',
      setUpdate: 'languages/update',
      reset: 'languages/reset',
    }),
    submit() {
      this.validate().then((valid) => {
        if (!valid) return

        let payload = Object.assign({}, this.language)
        if (!payload._id) {
          this.setCreate(payload).then((_) => {
            this.cancel()
          })
        } else {
          this.setUpdate(payload).then((_) => {
            this.cancel()
          })
        }
      })
    },
    cancel() {
      this.clear()
      this.$emit('close')
    },
    clear() {
      this.reset()
      this.$validator.reset()
    },
  },
}
</script>
